import { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import ProfileCard from "../../components/ProfileCard/ProfileCard";

import "./AboutUs.css";


import TeamYostian from "../../assets/team-yostian.webp";
import TeamDavid from "../../assets/team-david.webp";
import TeamHilary from "../../assets/team-hilary.webp";
import TeamSnayder from "../../assets/team-snayder.jpg";
import TeamMarlon from "../../assets/team-marlon.webp";
import TeamMarlonM from "../../assets/team-MarlonM.webp";
export default function Aboutus() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const { t } = useTranslation();

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Animaciones para roadmap, equipo, etc.
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const slideLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  // Datos del equipo
  const teamMembers = [
    {
      name: "Snayder Rodríguez",
      image: TeamSnayder,
      role: t("aboutUs.roles.backend"),
      description:
        "Secures AI applications by designing and implementing resilient cloud infrastructures.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/jakub-kohutik-quesada-b9b31b1a1/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=jakub@zenitailab.com",
        },
      ],
    },
    {
      name: "Yostian Campos",
      image: TeamYostian,
      role: t("aboutUs.roles.frontend"),
      description:
        "Crafts user-friendly interfaces with a focus on responsiveness and seamless user experiences.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/yostian-campos-0490a8321/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=yostian@zenitailab.com",
        },
      ],
    },
    {
      name: "Marlon Marin",
      image: TeamMarlon,
      role: t("aboutUs.roles.projectManager"),
      description:
        "Defines strategy and manages operations, partnerships, financial growth, AI product development, and market expansion.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/marlon-marin-productividad-ba571a2b/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=marlon@zenitailab.com",
        },
      ],
    },
    {
      name: "David Mora",
      image: TeamDavid,
      role: t("aboutUs.roles.aiEngineer"),
      description:
        "Defines technology strategy and oversees AI research, infrastructure, scalability, and product development.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/ddmoracr/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=david@zenitailab.com",
        },
      ],
    },
    {
      name: "Hilary Johnson",
      image: TeamHilary,
      role: t("aboutUs.roles.uiUx"),
      description:
        "Designs intuitive layouts and stunning visuals that enhance user engagement.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/hilary-johnson-s/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=hilary@zenitailab.com",
        },
      ],
    },
    {
      name: "Marlon Marin",
      image: TeamMarlonM,
      role: t("aboutUs.roles.machineLearning"),
      description:
        "build and deploy ML solutions to solve complex problems and drive smarter decisions through data.",
      socialLinks: [
        {
          platform: "linkedin",
          link: "https://www.linkedin.com/in/marlon-marin-productividad-ba571a2b/",
        },
        {
          platform: "envelope",
          link: "https://mail.google.com/mail/?view=cm&to=marlon@zenitailab.com",
        },
      ],
    },
  ];

  const handleCardClick = (index) => {
    setSelectedCard(selectedCard === index ? null : index);
  };

  return (
    <div className="about-us-container">
      <Header />

      {/* Sección Misión / Visión - ocupa toda la pantalla */}
      <section className="mission-vision-section">
        <div className="mission-vision-container">
          <div className="mission-vision-card">
            <h2>{t("aboutUs.mission.title")}</h2>
            <p>{t("aboutUs.mission.text")}</p>
          </div>
          <div className="mission-vision-card">
            <h2>{t("aboutUs.vision.title")}</h2>
            <p>{t("aboutUs.vision.text")}</p>
          </div>
        </div>
      </section>

      {/* Roadmap */}
      <motion.div
        className="roadmap-section"
        variants={fadeIn}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          className="roadmap-title"
          variants={fadeIn}
          transition={{ duration: 0.8 }}
        >
          {t("aboutUs.roadmap.title")}
        </motion.h1>
<motion.p
  className="roadmap-description"
  variants={fadeIn}
  transition={{ duration: 0.8 }}
>
  {/* “Press the circle” en blanco y bold */}
  <span className="roadmap-highlight">
    {t('aboutUs.roadmap.pressTheCircleHighlight')}
  </span>{' '}
  {/* “to discover our key objectives” en gris claro */}
  {t('aboutUs.roadmap.pressTheCircleRest')}
</motion.p>

        <motion.div
          className="roadmap-timeline"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
        >
          {Object.keys(
            t("aboutUs.roadmap.quarters", { returnObjects: true })
          ).map((quarterKey) => {
            const quarter = t(`aboutUs.roadmap.quarters.${quarterKey}`);
            return (
              <motion.div
                className="roadmap-item"
                key={quarterKey}
                variants={fadeIn}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.8 }}
                onClick={() =>
                  openModal(
                    quarter,
                    t(`aboutUs.roadmap.modalContent.${quarterKey}`, {
                      returnObjects: true,
                    })
                  )
                }
              >
                <div className="roadmap-circle" />
                <div className="roadmap-label">{quarter}</div>
                <div className="roadmap-year">{t("aboutUs.roadmap.year")}</div>
              </motion.div>
            );
          })}
        </motion.div>
      </motion.div>

      {/* Meet the Team */}
      <motion.div
        className="meet-the-team-section"
        variants={fadeIn}
        initial="hidden"
        animate="visible"
      >
        <h1 className="team-title">{t("aboutUs.meetTheTeam")}</h1>
        <div className="team-container">
          {teamMembers.map((member, index) => (
            <ProfileCard
              key={index}
              name={member.name}
              image={member.image}
              role={member.role}
              description={member.description}
              socialLinks={member.socialLinks}
              isSelected={selectedCard === index}
              onClick={() => handleCardClick(index)}
            />
          ))}
        </div>
      </motion.div>

      {/* Modal Roadmap */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <motion.div
            className="modal-content"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>{modalTitle}</h2>
            </div>
            <div className="modal-year">
              {modalTitle} {t("aboutUs.roadmap.year")}
            </div>
            <ul className="modal-content-list">
              {modalContent.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <button className="modal-close-button" onClick={closeModal}>
              X
            </button>
          </motion.div>
        </div>
      )}
    </div>
  );
}
